import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_SECURITY_AGREEMENT_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_SECURITY_AGREEMENT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_SECURITY_AGREEMENT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_SECURITY_AGREEMENT);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_SECURITY_AGREEMENT> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_SECURITY_AGREEMENT = {
	seal4: 'Seal4',
	seal3: 'Seal3',
	seal2: 'Seal2',
	witness4: 'WITNESS4',
	witness3: 'WITNESS3',
	witness2: 'WITNESS2',
	debtorAddress3: 'debtorAddress3',
	debtorAddress4: 'debtorAddress4',
	city4: 'city4',
	city3: 'city3',
	debtorName4: 'debtorName4',
	postalCode4: 'postalCode4',
	dateOfBirth4: 'dateOfBirth4',
	province4: 'province4',
	postalCode3: 'postalCode3',
	dateOfBirth3: 'dateOfBirth3',
	city2: 'city2',
	debtorAddress2: 'debtorAddress2',
	province3: 'province3',
	debtorName3: 'debtorName3',
	province2: 'province2',
	postalCode2: 'postalCode2',
	dateOfBirth2: 'dateOfBirth2',
	debtorName2: 'debtorName2',
	seal: 'Seal',
	witness: 'WITNESS',
	date: 'MonthDayYear',
	dateOfBirth: 'dateOfBirth',
	companyName: 'companyName',
	bankAddress: 'bankAddress',
	description: 'collateralDescription',
	collateralLocation: 'collateralLocation',
	debtAmount: 'debtAmount',
	companyAddress: 'companyAddress',
	city: 'city',
	debtorAddress: 'debtorAddress',
	province: 'province',
	postalCode: 'postalCode',
	debtorName: 'debtorName',
};
export interface RBC_RESIDENTIAL_SECURITY_AGREEMENT {
	companyAddress: string;
	companyName: string;
	debtAmount: string;
	description: string;
	collateralLocation: string;

	debtorName: string;
	debtorAddress: string;
	city: string;
	province: string;
	postalCode: string;
	dateOfBirth: string;

	debtorName2: string;
	debtorAddress2: string;
	city2: string;
	province2: string;
	postalCode2: string;
	dateOfBirth2: string;

	debtorName3: string;
	debtorAddress3: string;
	city3: string;
	province3: string;
	postalCode3: string;
	dateOfBirth3: string;

	debtorName4: string;
	debtorAddress4: string;
	city4: string;
	province4: string;
	postalCode4: string;
	dateOfBirth4: string;

	date: string;

	witness: string;
	witness2: string;
	witness3: string;
	witness4: string;
	seal: string;
	seal2: string;
	seal3: string;
	seal4: string;

	bankAddress: string;
}
